export default __webpack_public_path__ + "b9199e7cb5b85e193ea27f07fc76ee06.png";